import { reactLocalStorage } from 'reactjs-localstorage'
import { loginSuccess } from '../store/auth/actions'

/**
 * Persist the exchange response to localStorage, dispatch loginSuccess,
 * and navigate to the redirectTo path.
 *
 * @param {object} data           - Response body from GET /api/auth/exchange
 * @param {function} dispatch     - Redux dispatch (from useDispatch)
 * @param {object}  history       - React Router history
 */
export const handleExchangeSuccess = (data, dispatch, history) => {
    reactLocalStorage.set('token', data.token)
    reactLocalStorage.set('profile', data.profile)
    dispatch(loginSuccess(data.profile))

    // Persist impersonation state for the ImpersonationBanner
    if (data.isImpersonation) {
        sessionStorage.setItem('isImpersonation', '1')
        sessionStorage.setItem('impersonationAdminEmail', data.adminEmail || 'Admin')
    } else {
        sessionStorage.removeItem('isImpersonation')
        sessionStorage.removeItem('impersonationAdminEmail')
    }

    history.push(data.redirectTo || '/dashboard')
}
